    <div [formGroup]="form" class="mt-4"> 
        <div class="col-6">
            <ca-form-field>
                <ca-label>{{'GUARDAR_PROYECTO.DATOS_PROYECTO.NOMBRE_PROYECTO' | translate}}</ca-label>
                <input caInput formControlName="nombre-proy" placeholder="{{'GUARDAR_PROYECTO.DATOS_PROYECTO.NOMBRE_PROYECTO' | translate}}" type="text"/>
                <ca-error *ngIf="form.controls['nombre-proy'].errors?.required">{{'ERROR.ERROR_CAMPO_REQUERIDO' | translate}}</ca-error>
                <ca-hint>{{'GUARDAR_PROYECTO.DATOS_PROYECTO.HINT_NOMBRE_PROYECTO' | translate}}</ca-hint>
            </ca-form-field>
        </div>
    </div>